module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also by CJ Carver")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE HARRY HOPE SERIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Cold Echo")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Deep Black Lies")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE LIA SHAN THRILLER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Snow Thief")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE NICK ASHDOWN THRILLER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Over Your Shoulder")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE DAN FORRESTER SERIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Spare Me The Truth")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Tell Me A Lie")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Know Me Now")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Scare Me To Death")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE JAY MCCAULAY SERIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Gone Without Trace")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Back With Vengeance")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("The Honest Assassin")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE INDIA KANE SERIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Blood Junction")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Black Tide")])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTHER NOVELS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Dead Heat")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_vm._v("Beneath The Snow")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35318374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alsobycjcarver.vue
// module id = 75
// module chunks = 0